import React from 'react'

export default () => (
  <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1L1.5 7.5M1.5 7.5L8 14M1.5 7.5L17 7.5" stroke="#003A80" strokeWidth="2"/>
  </svg>
)
